import { CommandAction } from "src/app/abstract/command/command-action.service";
import { WidgetsTextModel } from "src/app/models/widgets/widgets-text.model";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";

@Injectable()
export class CommandTextService extends CommandAction {

    public execute(parent: WidgetsAbstract, widget: WidgetsAbstract): WidgetsTextModel {
        const newHeader = new WidgetsTextModel();
        newHeader.parentId = parent.id;
        return newHeader;          
    }
}
